var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrello(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0842 2.11719H5.11725C4.33244 2.11825 3.58007 2.43041 3.02503 2.98526C2.46999 3.54011 2.15757 4.29238 2.15625 5.07719V24.0442C2.15704 24.8292 2.46909 25.5818 3.02397 26.1371C3.57885 26.6923 4.33127 27.0049 5.11625 27.0062H24.0822C24.8674 27.0051 25.6201 26.6927 26.1752 26.1374C26.7303 25.5821 27.0425 24.8293 27.0432 24.0442V5.07819C27.0422 4.29338 26.73 3.541 26.1752 2.98597C25.6203 2.43093 24.8691 2.11851 24.0842 2.11719ZM12.8763 20.0412C12.8763 20.3022 12.7726 20.5524 12.588 20.737C12.4035 20.9215 12.1532 21.0252 11.8923 21.0252H7.73525C7.47428 21.0252 7.22399 20.9215 7.03946 20.737C6.85492 20.5524 6.75125 20.3022 6.75125 20.0412V7.69619C6.75112 7.56688 6.77647 7.43882 6.82587 7.31932C6.87526 7.19982 6.94772 7.09123 7.0391 6.99975C7.13049 6.90827 7.23901 6.8357 7.35846 6.78619C7.47791 6.73667 7.60595 6.71119 7.73525 6.71119H11.8933C12.0226 6.71119 12.1506 6.73667 12.27 6.78619C12.3895 6.8357 12.498 6.90827 12.5894 6.99975C12.6808 7.09123 12.7532 7.19982 12.8026 7.31932C12.852 7.43882 12.8774 7.56688 12.8772 7.69619L12.8763 20.0412ZM22.4492 14.3722C22.452 14.5032 22.4287 14.6334 22.3805 14.7552C22.3323 14.877 22.2602 14.988 22.1686 15.0816C22.0769 15.1752 21.9675 15.2496 21.8467 15.3003C21.726 15.3511 21.5963 15.3772 21.4653 15.3772H17.3073C17.0464 15.3769 16.7962 15.2732 16.6117 15.0887C16.4273 14.9042 16.3235 14.6541 16.3232 14.3932V7.69619C16.3232 7.43512 16.4269 7.18474 16.6114 7.00004C16.7959 6.81535 17.0462 6.71145 17.3073 6.71119H21.4653C21.5946 6.71119 21.7226 6.73667 21.842 6.78619C21.9615 6.8357 22.07 6.90827 22.1614 6.99975C22.2528 7.09123 22.3252 7.19982 22.3746 7.31932C22.424 7.43882 22.4494 7.56688 22.4492 7.69619V14.3732V14.3722Z",
    fill: "url(#paint0_linear_1685_30504)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1685_30504",
    x1: 14.6002,
    y1: 27.0062,
    x2: 14.6002,
    y2: 2.11719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrello);
export default __webpack_public_path__ + "static/media/trello.6126295dfcedd9d290c9fafb8c27b5a7.svg";
export { ForwardRef as ReactComponent };